<th class="text-right">
    <div *ngIf="!isEditing">{{azimuth.title}}</div>
    <div *ngIf="isEditing">
        <input name="azimuthTitle" type='text' class="w-100"
            [(ngModel)]="azimuth.title" #azimuthTitleInput="ngModel" required
            [ngClass]="{ 'invalid-input': azimuthTitleInput.invalid && (azimuthTitleInput.dirty || azimuthTitleInput.touched)}"
        >
    </div>
</th>
<td>
    <div class="d-flex flex-row justify-content-between">
        <div>
            {{oppositeAngle(azimuth.angle)}}&deg;<i class="fa fa-arrows-alt-h"></i>
            <ng-container *ngIf="!isEditing">
                {{azimuth.angle}}
            </ng-container>
            <input *ngIf="isEditing" name="azimuthTitle" type='number' style="width: 2.75em;"
                [(ngModel)]="azimuth.angle" #azimuthAngleInput="ngModel" [min]="0" [lt]="360"
                [ngClass]="{ 'invalid-input': azimuthAngleInput.invalid && (azimuthAngleInput.dirty || azimuthAngleInput.touched)}"
            >
            &deg;
            <i class="px-1 fa fa-long-arrow-alt-up align-self-center" 
            [ngStyle]="{transform: 'rotate('+azimuth.angle+'deg)'}"></i>                    
        </div>
        <div *ngIf="isEditing">
            <button (click)="onDelete()" class="btn btn-warning btn-sm small"><i class="fa fa-minus-square"></i> Delete</button>
        </div>
    </div>
</td>
